import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-238bda24"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 3 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 5 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 7 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 9 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 11 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 13 }
const _hoisted_16 = { key: 14 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 16 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 18 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 20 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 22 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 24 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c","margin-right":"4px"} }, "*", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "cargo-quantities-total" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_summary_time = _resolveComponent("order-summary-time")!
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_miezz_common_history = _resolveComponent("miezz-common-history")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_order_supplier = _resolveComponent("order-supplier")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_express_tracking = _resolveComponent("express-tracking")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, {
      center: _withCtx(() => [
        _createVNode(_component_order_summary_time, { id: _ctx._orderId }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_page_list, {
          modelValue: _ctx.list,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.list) = $event)),
          onHandleGet: _ctx.handleGet,
          onHandleTopButtonClick: _ctx.handleTopButtonClick,
          onHandleRowButtonClick: _ctx.handleRowButtonClick
        }, {
          "column-header": _withCtx(({ model }) => [
            _createElementVNode("span", null, _toDisplayString(model.Label), 1),
            (model.Prop != 'SupplierLabel' || !_ctx.logier?.DisabledReadSupplier)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  title: "批量操作",
                  class: "batch-edit",
                  onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Edit)
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_1))
              : _createCommentVNode("", true)
          ]),
          column: _withCtx(({ model, row }) => [
            (model.Prop == 'PlanCarryContainerTime' && _ctx.canEdit)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                }, [
                  _createVNode(_component_miezz_text_ellipsis, {
                    text: _ctx.formatTime(row.PlanCarryContainerTime),
                    style: _normalizeStyle(row.PlanCarryContainerTime ? 'color: #409EFF' : '')
                  }, null, 8, ["text", "style"])
                ], 8, _hoisted_2))
              : (model.Prop == 'PlanCarryContainerTime')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_miezz_text_ellipsis, {
                      text: _ctx.formatTime(row.PlanCarryContainerTime)
                    }, null, 8, ["text"])
                  ]))
                : _createCommentVNode("", true),
            (model.Prop == 'CarryContainerTime' && _ctx.canEdit)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                }, [
                  _createVNode(_component_miezz_text_ellipsis, {
                    text: _ctx.formatTime(row.CarryContainerTime),
                    style: _normalizeStyle(row.CarryContainerTime ? 'color: #409EFF' : '')
                  }, null, 8, ["text", "style"])
                ], 8, _hoisted_4))
              : (model.Prop == 'CarryContainerTime')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_miezz_text_ellipsis, {
                      text: _ctx.formatTime(row.CarryContainerTime)
                    }, null, 8, ["text"])
                  ]))
                : (model.Prop == 'CarryPlanTime' && _ctx.canEdit)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 4,
                      onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                    }, [
                      _createVNode(_component_miezz_text_ellipsis, {
                        text: _ctx.formatTime(row.CarryPlanTime),
                        style: _normalizeStyle(row.CarryPlanTime ? 'color: #409eff' : '')
                      }, null, 8, ["text", "style"])
                    ], 8, _hoisted_6))
                  : (model.Prop == 'CarryPlanTime')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: _ctx.formatTime(row.CarryPlanTime)
                        }, null, 8, ["text"])
                      ]))
                    : (
            model.Prop == 'CarryAddress' && (_ctx.canEdit || row.CarryAddressId)
          )
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 6,
                          onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                        }, [
                          _createVNode(_component_miezz_text_ellipsis, {
                            text: row.CarryAddressId ? '查看详情' : '暂无数据',
                            style: _normalizeStyle(row.CarryAddressId ? 'color: #409EFF' : '')
                          }, null, 8, ["text", "style"])
                        ], 8, _hoisted_8))
                      : (model.Prop == 'CarryAddress')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                          ]))
                        : (
            model.Prop == 'HasCargoQuantities' &&
            (_ctx.canEdit || row.HasCargoQuantities)
          )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 8,
                              onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                            }, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: row.HasCargoQuantities ? '查看详情' : '暂无数据',
                                style: _normalizeStyle(row.HasCargoQuantities ? 'color: #409EFF' : '')
                              }, null, 8, ["text", "style"])
                            ], 8, _hoisted_10))
                          : (model.Prop == 'HasCargoQuantities')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                              ]))
                            : (model.Prop == 'HasCargos' && (_ctx.canEdit || row.HasCargos))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 10,
                                  onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                }, [
                                  _createVNode(_component_miezz_text_ellipsis, {
                                    text: row.HasCargos ? '查看详情' : '暂无数据',
                                    style: _normalizeStyle(row.HasCargos ? 'color: #409EFF' : '')
                                  }, null, 8, ["text", "style"])
                                ], 8, _hoisted_12))
                              : (model.Prop == 'HasCargos')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                                  ]))
                                : (model.Prop == 'AllCarryTime' && _ctx.canEdit)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 12,
                                      onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                    }, [
                                      _createVNode(_component_miezz_text_ellipsis, {
                                        text: _ctx.formatTime(row.AllCarryTime),
                                        style: _normalizeStyle(row.AllCarryTime ? 'color: #409EFF' : '')
                                      }, null, 8, ["text", "style"])
                                    ], 8, _hoisted_14))
                                  : (model.Prop == 'AllCarryTime')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createVNode(_component_miezz_text_ellipsis, {
                                          text: _ctx.formatTime(row.AllCarryTime)
                                        }, null, 8, ["text"])
                                      ]))
                                    : (
            model.Prop == 'SupplierLabel' &&
            (_ctx.logier?.CompanyType == _ctx.EnumCompanyType.Customer ||
              _ctx.logier?.DisabledReadSupplier)
          )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          _createVNode(_component_miezz_text_ellipsis, {
                                            text: _ctx.logier.ServiceProviderCompanyNameZh,
                                            style: _normalizeStyle(_ctx.logier.ServiceProviderCompanyNameZh ? 'color: #409EFF' : '')
                                          }, null, 8, ["text", "style"])
                                        ]))
                                      : (
            model.Prop == 'SupplierLabel' &&
            (_ctx.canEdit || row.SupplierLabel != '暂无数据')
          )
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 15,
                                            onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                          }, [
                                            _createVNode(_component_miezz_text_ellipsis, {
                                              text: row.SupplierLabel ? row.SupplierLabel : '暂无数据',
                                              style: _normalizeStyle(
              row.SupplierLabel && row.SupplierLabel != '暂无数据'
                ? 'color: #409EFF'
                : ''
            )
                                            }, null, 8, ["text", "style"])
                                          ], 8, _hoisted_17))
                                        : (model.Prop == 'SupplierLabel')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                              _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                                            ]))
                                          : (model.Prop == 'HasCodes' && (_ctx.canEdit || row.HasCodes))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 17,
                                                onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                              }, [
                                                _createVNode(_component_miezz_text_ellipsis, {
                                                  text: row.HasCodes ? '查看详情' : '暂无数据',
                                                  style: _normalizeStyle(row.HasCodes ? 'color: #409EFF' : '')
                                                }, null, 8, ["text", "style"])
                                              ], 8, _hoisted_19))
                                            : (model.Prop == 'HasCodes')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                  _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                                                ]))
                                              : _createCommentVNode("", true),
            (
            model.Prop == 'DeliveryAddress' &&
            (_ctx.canEdit || row.DeliveryAddressId)
          )
              ? (_openBlock(), _createElementBlock("a", {
                  key: 19,
                  onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                }, [
                  _createVNode(_component_miezz_text_ellipsis, {
                    text: 
              row.DeliveryAddressId && row.PlanDeliveryTime
                ? '查看详情'
                : '暂无数据'
            ,
                    style: _normalizeStyle(
              row.DeliveryAddressId && row.PlanDeliveryTime
                ? 'color: #409EFF'
                : ''
            )
                  }, null, 8, ["text", "style"])
                ], 8, _hoisted_21))
              : (model.Prop == 'DeliveryAddress')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                  ]))
                : (model.Prop == 'AllDeliveryTime' && _ctx.canEdit)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 21,
                      onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                    }, [
                      _createVNode(_component_miezz_text_ellipsis, {
                        text: _ctx.formatTime(row.AllDeliveryTime),
                        style: _normalizeStyle(row.AllDeliveryTime ? 'color: #409EFF' : '')
                      }, null, 8, ["text", "style"])
                    ], 8, _hoisted_23))
                  : (model.Prop == 'AllDeliveryTime')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: _ctx.formatTime(row.AllDeliveryTime)
                        }, null, 8, ["text"])
                      ]))
                    : (model.Prop == 'Files' && (_ctx.canEdit || row.Files.length > 0))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 23,
                          onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                        }, [
                          _createVNode(_component_miezz_text_ellipsis, {
                            text: row.Files && row.Files.length > 0 ? '查看详情' : '暂无数据',
                            style: _normalizeStyle(row.Files && row.Files.length > 0 ? 'color: #409EFF' : '')
                          }, null, 8, ["text", "style"])
                        ], 8, _hoisted_25))
                      : (model.Prop == 'Files')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                          ]))
                        : (model.Prop == 'Process')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 25,
                              onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                            }, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: "查看详情",
                                style: {"color":"#409eff"}
                              })
                            ], 8, _hoisted_27))
                          : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleRowButtonClick"]),
        (_ctx.canAdd)
          ? (_openBlock(), _createBlock(_component_miezz_button, {
              key: 0,
              style: {"color":"#fe995b"},
              model: _ctx.btnAdd,
              onHandleClick: _ctx.handleTopButtonClick
            }, null, 8, ["model", "onHandleClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.logier?.CompanyType != _ctx.EnumCompanyType.Customer)
      ? (_openBlock(), _createBlock(_component_miezz_common_history, {
          key: 0,
          modelValue: _ctx.histories,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.histories) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalPlanCarryContainerTime,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalPlanCarryContainerTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formPlanCarryContainerTime,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formPlanCarryContainerTime) = $event)),
          ref: "ref-form-plan-carry-container-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'PlanCarryContainerTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formPlanCarryContainerTime.Data.PlanCarryContainerTime,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formPlanCarryContainerTime.Data.PlanCarryContainerTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCarryContainerTime,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalCarryContainerTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formCarryContainerTime,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formCarryContainerTime) = $event)),
          ref: "ref-form-carry-container-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'CarryContainerTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formCarryContainerTime.Data.CarryContainerTime,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formCarryContainerTime.Data.CarryContainerTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date",
                      onChange: _ctx.handleChangeCarryContainerTime
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCarryPlanTime,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalCarryPlanTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formCarryPlanTime,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formCarryPlanTime) = $event)),
          ref: "ref-form-carry-plan-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'CarryPlanTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formCarryPlanTime.Data.CarryPlanTime,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formCarryPlanTime.Data.CarryPlanTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCarryAddress,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.modalCarryAddress) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formCarryAddress,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formCarryAddress) = $event)),
          ref: "ref-form-carry-address"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'CarryAddress')
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(_component_el_form_item, {
                    label: "公司名称",
                    prop: `CarryAddress.CompanyName`,
                    rules: _ctx.formCarryAddress.Rules.CompanyName
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formCarryAddress.Data.CarryAddress.CompanyName,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formCarryAddress.Data.CarryAddress.CompanyName) = $event)),
                            "fetch-suggestions": _ctx.getConpanyNames,
                            "trigger-on-focus": true,
                            clearable: "",
                            "value-key": "CompanyName",
                            onHandleSelect: _cache[13] || (_cache[13] = 
                (arg1) =>
                  _ctx.handleSelectCarryAddressCompanyName(
                    arg1,
                    _ctx.formCarryAddress.Data
                  )
              )
                          }, null, 8, ["modelValue", "fetch-suggestions"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.formCarryAddress.Data.CarryAddress.CompanyName ?? "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "坐标",
                    prop: `CarryAddress.AreaLabel`,
                    rules: _ctx.formCarryAddress.Rules.AreaLabel
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formCarryAddress.Data.CarryAddress.AreaLabel,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formCarryAddress.Data.CarryAddress.AreaLabel) = $event)),
                            "fetch-suggestions": _ctx.getAreas,
                            "trigger-on-focus": true,
                            clearable: "",
                            valueKey: "FullName",
                            onHandleSelect: _cache[15] || (_cache[15] = 
                (arg1) =>
                  _ctx.handleSelectCarryAddressArea(arg1, _ctx.formCarryAddress.Data)
              )
                          }, null, 8, ["modelValue", "fetch-suggestions"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.formCarryAddress.Data.CarryAddress.AreaLabel ?? "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "详细地址",
                    prop: `CarryAddress.Address`,
                    rules: _ctx.formCarryAddress.Rules.Address
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formCarryAddress.Data.CarryAddress.Address,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formCarryAddress.Data.CarryAddress.Address) = $event)),
                            clearable: ""
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.formCarryAddress.Data.CarryAddress.Address ?? "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "计划时间",
                    prop: `CarryPlanTime`,
                    rules: _ctx.formCarryAddress.Rules.CarryPlanTime
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                            key: 0,
                            modelValue: _ctx.formCarryAddress.Data.CarryPlanTime,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formCarryAddress.Data.CarryPlanTime) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: "form-item-date"
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.formatTime(_ctx.formCarryAddress.Data.CarryPlanTime)), 1))
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "联系人",
                    prop: `CarryAddress.Contact`,
                    rules: _ctx.formCarryAddress.Rules.Contact
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formCarryAddress.Data.CarryAddress.Contact,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formCarryAddress.Data.CarryAddress.Contact) = $event)),
                            "fetch-suggestions": 
                (arg1, arg2) =>
                  _ctx.getContacts(arg1, _ctx.formCarryAddress.Data.CarryAddress, arg2)
              ,
                            "trigger-on-focus": true,
                            clearable: "",
                            "value-key": "Contact",
                            onHandleSelect: _cache[19] || (_cache[19] = 
                (arg1) =>
                  _ctx.handleSelectCarryAddressContact(arg1, _ctx.formCarryAddress.Data)
              ),
                            deleteOption: true,
                            onHandleDeleteOption: _cache[20] || (_cache[20] = 
                (arg1, arg2) =>
                  _ctx.handleDeleteContact(
                    arg1,
                    arg2,
                    _ctx.formCarryAddress.Data.CarryAddress
                  )
              )
                          }, null, 8, ["modelValue", "fetch-suggestions"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.formCarryAddress.Data.CarryAddress.Contact ?? "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "联系方式",
                    prop: `CarryAddress.ContactNumber`,
                    rules: _ctx.formCarryAddress.Rules.ContactNumber
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formCarryAddress.Data.CarryAddress.ContactNumber,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formCarryAddress.Data.CarryAddress.ContactNumber) = $event)),
                            clearable: ""
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.formCarryAddress.Data.CarryAddress.ContactNumber ?? "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "备注",
                    prop: `CarryAddress.Remark`,
                    rules: _ctx.formCarryAddress.Rules.Remark
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formCarryAddress.Data.CarryAddress.Remark,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formCarryAddress.Data.CarryAddress.Remark) = $event)),
                            type: "textarea",
                            rows: 5,
                            trim: false
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.formCarryAddress.Data.Remark ?? "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCargoQuantities,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.modalCargoQuantities) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formCargoQuantities.Data,
          rules: _ctx.formCargoQuantities.Rules,
          ref: "ref-form-cargo-quantities",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_miezz_page_list, {
              ref: "list-cargoQuantities",
              modelValue: _ctx.listCargoQuantities,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.listCargoQuantities) = $event)),
              onHandleSelect: _ctx.handleCargoQuantitiesSelect
            }, {
              "column-header": _withCtx(({ model }) => [
                (model.Prop == 'DeliveryQuantity')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("span", null, _toDisplayString(model.Label), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'DeliveryQuantity')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `Items[${index}]`,
                      rules: _ctx.formCargoQuantities.Rules.DeliveryQuantity,
                      class: "cargo-quantities-delivery-quantity"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.canEdit)
                          ? (_openBlock(), _createBlock(_component_miezz_input, {
                              key: 0,
                              modelValue: row.DeliveryQuantity,
                              "onUpdate:modelValue": ($event: any) => ((row.DeliveryQuantity) = $event),
                              pattern: "[0-9]",
                              number: true,
                              disabled: !_ctx.listCargoQuantities.SelectIds.contains(row.Id),
                              onHandleChange: _ctx.handleDeliveryQuantityChange
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleChange"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(row.DeliveryQuantity ?? 0), 1))
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onHandleSelect"]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_el_form_item, {
                label: "合计件数",
                prop: "TotalQuantity"
              }, {
                default: _withCtx(() => [
                  (_ctx.canEdit)
                    ? (_openBlock(), _createBlock(_component_miezz_input, {
                        key: 0,
                        modelValue: _ctx.formCargoQuantities.Data.TotalQuantity,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formCargoQuantities.Data.TotalQuantity) = $event)),
                        pattern: "[0-9]",
                        number: true,
                        disabled: 
              _ctx.listCargoQuantities.SelectRows?.any(
                (it) => (it.DeliveryQuantity ?? 0) > 0
              )
            
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "TotalQuantityChargeUnitEn" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.formCargoQuantities.Data.TotalQuantityChargeUnitEn,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formCargoQuantities.Data.TotalQuantityChargeUnitEn) = $event)),
                                clearable: false,
                                "fetch-suggestions": _ctx.getPackageKinds,
                                valueKey: "Label",
                                "trigger-on-focus": true,
                                deleteOption: true,
                                checkDeleteOption: (it) => it.Data.IsHistory,
                                onHandleDeleteOption: _ctx.handleDeletePackageKindContact
                              }, null, 8, ["modelValue", "fetch-suggestions", "checkDeleteOption", "onHandleDeleteOption"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.formCargoQuantities.Data.TotalQuantity ?? 0) + " " + _toDisplayString(_ctx.formCargoQuantities.Data.TotalQuantityChargeUnitEn), 1))
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "合计毛重",
                prop: "TotalGrossWeight"
              }, {
                default: _withCtx(() => [
                  (_ctx.canEdit)
                    ? (_openBlock(), _createBlock(_component_miezz_input, {
                        key: 0,
                        modelValue: _ctx.formCargoQuantities.Data.TotalGrossWeight,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formCargoQuantities.Data.TotalGrossWeight) = $event)),
                        pattern: "[0-9.]",
                        number: true,
                        numberFixed: 2,
                        disabled: 
              _ctx.listCargoQuantities.SelectRows?.any(
                (it) => (it.DeliveryQuantity ?? 0) > 0
              )
            
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.kgs,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.kgs) = $event)),
                            disabled: true
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.formCargoQuantities.Data.TotalGrossWeight ?? 0) + " kgs ", 1))
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "合计体积",
                prop: "TotalVolume"
              }, {
                default: _withCtx(() => [
                  (_ctx.canEdit)
                    ? (_openBlock(), _createBlock(_component_miezz_input, {
                        key: 0,
                        modelValue: _ctx.formCargoQuantities.Data.TotalVolume,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formCargoQuantities.Data.TotalVolume) = $event)),
                        pattern: "[0-9.]",
                        number: true,
                        numberFixed: 4,
                        disabled: 
              _ctx.listCargoQuantities.SelectRows?.any(
                (it) => (it.DeliveryQuantity ?? 0) > 0
              )
            
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.cbm,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.cbm) = $event)),
                            disabled: true
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.formCargoQuantities.Data.TotalVolume ?? 0) + " m³", 1))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAllCarryTime,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.modalAllCarryTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formAllCarryTime,
          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formAllCarryTime) = $event)),
          ref: "ref-form-all-carry-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'AllCarryTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formAllCarryTime.Data.AllCarryTime,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formAllCarryTime.Data.AllCarryTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date",
                      onChange: _ctx.handleChangeAllCarryTime
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_order_supplier, {
      ref: "ref-order-supplier",
      show: _ctx.showSupplier,
      canEdit: _ctx.canEdit,
      onHandleSave: _ctx.handleSaveSupplier
    }, null, 8, ["show", "canEdit", "onHandleSave"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCodes,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.modalCodes) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formCodes,
          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formCodes) = $event)),
          ref: "ref-form-codes"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'Codes')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  "label-width": "0px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formCodes.Data.Codes, (main, mi) => {
                      return (_openBlock(), _createElementBlock("div", { key: mi }, [
                        _createVNode(_component_el_form_item, {
                          label: `主单号${mi + 1}`,
                          prop: `Codes[${mi}]`,
                          rules: _ctx.formCodes.Rules.MainCode,
                          class: "main-code"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.canEdit)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: main.Code,
                                    "onUpdate:modelValue": ($event: any) => ((main.Code) = $event),
                                    pattern: "[0-9a-zA-Z]",
                                    upperCase: true,
                                    trimAll: true,
                                    style: {"width":"calc(100% - 50px)","margin-right":"10px"}
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  (mi > 0)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        type: "text",
                                        icon: "Delete",
                                        style: {"color":"#f56c6c"},
                                        onClick: ($event: any) => (_ctx.handleDeleteMainCode(mi))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(main.Code ?? "暂无数据"), 1))
                          ]),
                          _: 2
                        }, 1032, ["label", "prop", "rules"]),
                        _createVNode(_component_el_form_item, {
                          label: "分单号",
                          class: "children-code-wrapper",
                          rules: _ctx.formCodes.Rules.ChildrenCode
                        }, {
                          default: _withCtx(() => [
                            (_ctx.canEdit)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(main.Children, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: i,
                                      prop: `Codes[${mi}].Children[${i}]`,
                                      rules: _ctx.formCodes.Rules.ChildrenCode,
                                      class: "children-code"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          modelValue: item.Code,
                                          "onUpdate:modelValue": ($event: any) => ((item.Code) = $event),
                                          pattern: "[0-9a-zA-Z]",
                                          upperCase: true,
                                          trimAll: true,
                                          style: {"width":"calc(100% - 40px)","margin-right":"10px"}
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        _createVNode(_component_el_button, {
                                          type: "text",
                                          icon: "Delete",
                                          style: {"color":"#f56c6c"},
                                          onClick: ($event: any) => (_ctx.handleDeleteChildrenCode(main, i))
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]))
                                  }), 128)),
                                  _createVNode(_component_el_form_item, {
                                    "label-width": "0px",
                                    style: {"display":"inline-flex"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_button, {
                                        style: {"color":"#73767a"},
                                        model: _ctx.btnAddChildrenCode,
                                        onHandleClick: 
                      (arg1, arg2) => _ctx.handleAddChildrenCode(main, arg2)
                    
                                      }, null, 8, ["model", "onHandleClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(main.Children?.map((it) => it.Code).join("/")), 1))
                          ]),
                          _: 2
                        }, 1032, ["rules"])
                      ]))
                    }), 128)),
                    _createVNode(_component_el_form_item, { "label-width": "150px" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_button, {
                          model: _ctx.btnAddMainCode,
                          onHandleClick: _ctx.handleTopButtonClick
                        }, null, 8, ["model", "onHandleClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalDeliveryAddress,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.modalDeliveryAddress) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formDeliveryAddress,
          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.formDeliveryAddress) = $event)),
          ref: "ref-form-delivery-address"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'DeliveryAddress')
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createVNode(_component_el_form_item, {
                    label: "公司名称",
                    prop: `DeliveryAddress.CompanyName`,
                    rules: _ctx.formDeliveryAddress.Rules.CompanyName
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formDeliveryAddress.Data.DeliveryAddress.CompanyName,
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formDeliveryAddress.Data.DeliveryAddress.CompanyName) = $event)),
                            "fetch-suggestions": _ctx.getConpanyNames,
                            "trigger-on-focus": true,
                            clearable: "",
                            "value-key": "CompanyName",
                            onHandleSelect: _cache[39] || (_cache[39] = 
                (arg1) =>
                  _ctx.handleSelectDeliveryAddressCompanyName(
                    arg1,
                    _ctx.formDeliveryAddress.Data
                  )
              )
                          }, null, 8, ["modelValue", "fetch-suggestions"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.formDeliveryAddress.Data.DeliveryAddress.CompanyName ??
                "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "坐标",
                    prop: `DeliveryAddress.AreaLabel`,
                    rules: _ctx.formDeliveryAddress.Rules.AreaLabel
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formDeliveryAddress.Data.DeliveryAddress.AreaLabel,
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formDeliveryAddress.Data.DeliveryAddress.AreaLabel) = $event)),
                            "fetch-suggestions": _ctx.getAreas,
                            "trigger-on-focus": true,
                            clearable: "",
                            valueKey: "FullName",
                            onHandleSelect: _cache[41] || (_cache[41] = 
                (arg1) =>
                  _ctx.handleSelectDeliveryAddressArea(
                    arg1,
                    _ctx.formDeliveryAddress.Data
                  )
              )
                          }, null, 8, ["modelValue", "fetch-suggestions"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.formDeliveryAddress.Data.DeliveryAddress.AreaLabel ?? "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "详细地址",
                    prop: `DeliveryAddress.Address`,
                    rules: _ctx.formDeliveryAddress.Rules.Address
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formDeliveryAddress.Data.DeliveryAddress.Address,
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.formDeliveryAddress.Data.DeliveryAddress.Address) = $event)),
                            clearable: ""
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.formDeliveryAddress.Data.DeliveryAddress.Address ?? "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "计划抵达时间",
                    prop: `PlanDeliveryTime`,
                    rules: _ctx.formDeliveryAddress.Rules.PlanDeliveryTime
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                            key: 0,
                            modelValue: _ctx.formDeliveryAddress.Data.PlanDeliveryTime,
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formDeliveryAddress.Data.PlanDeliveryTime) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: "form-item-date"
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.formatTime(_ctx.formDeliveryAddress.Data.PlanDeliveryTime)), 1))
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "联系人",
                    prop: `DeliveryAddress.Contact`,
                    rules: _ctx.formDeliveryAddress.Rules.Contact
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formDeliveryAddress.Data.DeliveryAddress.Contact,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.formDeliveryAddress.Data.DeliveryAddress.Contact) = $event)),
                            "fetch-suggestions": 
                (arg1, arg2) =>
                  _ctx.getContacts(
                    arg1,
                    _ctx.formDeliveryAddress.Data.DeliveryAddress,
                    arg2
                  )
              ,
                            "trigger-on-focus": true,
                            clearable: "",
                            "value-key": "Contact",
                            onHandleSelect: _cache[45] || (_cache[45] = 
                (arg1) =>
                  _ctx.handleSelectDeliveryAddressContact(
                    arg1,
                    _ctx.formDeliveryAddress.Data
                  )
              ),
                            deleteOption: true,
                            onHandleDeleteOption: _cache[46] || (_cache[46] = 
                (arg1, arg2) =>
                  _ctx.handleDeleteContact(
                    arg1,
                    arg2,
                    _ctx.formDeliveryAddress.Data.DeliveryAddress
                  )
              )
                          }, null, 8, ["modelValue", "fetch-suggestions"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.formDeliveryAddress.Data.DeliveryAddress.Contact ?? "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "联系方式",
                    prop: `DeliveryAddress.ContactNumber`,
                    rules: _ctx.formDeliveryAddress.Rules.ContactNumber
                  }, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            modelValue: _ctx.formDeliveryAddress.Data.DeliveryAddress.ContactNumber,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.formDeliveryAddress.Data.DeliveryAddress.ContactNumber) = $event)),
                            clearable: ""
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.formDeliveryAddress.Data.DeliveryAddress.ContactNumber ??
                "暂无数据"), 1))
                    ]),
                    _: 1
                  }, 8, ["prop", "rules"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAllDeliveryTime,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.modalAllDeliveryTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formAllDeliveryTime,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.formAllDeliveryTime) = $event)),
          ref: "ref-form-all-delivery-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'AllDeliveryTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formAllDeliveryTime.Data.AllDeliveryTime,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.formAllDeliveryTime.Data.AllDeliveryTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date",
                      onChange: _ctx.handleChangeAllDeliveryTime
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalFile,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.modalFile) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formFile,
          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.formFile) = $event)),
          ref: "ref-form-file"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'Files')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_upload, {
                      modelValue: _ctx.formFile.Data.Files,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.formFile.Data.Files) = $event)),
                      path: "order/pool/container-trailer/file",
                      prop: "File",
                      maxSize: 2 * 1024 * 1024,
                      preview: !_ctx.canEdit
                    }, null, 8, ["modelValue", "preview"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAdd,
      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.modalAdd) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formAdd.Data,
          rules: _ctx.formAdd.Rules,
          "label-width": "150px",
          ref: "ref-form-add"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "委托人",
              prop: "ClientCompanyId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.formAdd.Data.ClientCompanyId,
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.formAdd.Data.ClientCompanyId) = $event)),
                  options: _ctx.clients
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Booking No.",
              prop: "PoolId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.formAdd.Data.PoolId,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.formAdd.Data.PoolId) = $event)),
                  options: _ctx.orders,
                  disabled: !_ctx.formAdd.Data.ClientCompanyId
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalTracking,
      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.modalTracking) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_express_tracking, {
          modelValue: _ctx.id,
          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.id) = $event)),
          onHandleUpdateEntity: _ctx.handleGet
        }, null, 8, ["modelValue", "onHandleUpdateEntity"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}